export { default } from './DidNotFindServiceItem';



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindServiceItem/index.js